// extracted by mini-css-extract-plugin
export default {"officers":"Officers_officers__vk0nv","officersHeader":"Officers_officersHeader__q6r9q","subsectionTitle":"Officers_subsectionTitle__ErxTU","addButton":"Officers_addButton__WwyB+"};